module.exports = __webpack_public_path__ + "static/media/logoalvin.b06f09e6.svg";